export const IRL_EVENT_ACTIVE_ONLY_AVAILABILITY_FLAG = 'pos.marketing.irl-event-active-only-availability.rollout';
